var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMorocco(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4557 13.1306H18.2323L16.0002 6.2608L13.7681 13.1306H6.54468L12.3885 17.3763L10.1563 24.2462L16.0002 20.0004L21.8441 24.2463L19.6119 17.3764L25.4557 13.1306ZM14.0241 16.8449L14.7789 14.5218H17.2214L17.9763 16.8449V16.8449L16.0002 18.2806L14.0241 16.8449L14.0241 16.8449ZM16.7694 13.1306H15.231L16.0002 10.7631L16.7694 13.1306ZM19.1597 15.9851L18.6843 14.5219H21.1736L19.1597 15.9851ZM13.316 14.5219L12.8406 15.9851L10.8266 14.5219H13.316ZM12.8027 20.6037L13.572 18.2363L14.8167 19.1406L12.8027 20.6037ZM17.1837 19.1406L18.4284 18.2364L19.1976 20.6038L17.1837 19.1406Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorocco);
export default __webpack_public_path__ + "static/media/morocco.cb32c129.svg";
export { ForwardRef as ReactComponent };